import { kebabCase } from 'lodash';

import { Heading, Grid, useTheme, Text } from '@simplywallst/ui-core';

import { useHtmlReactParser } from '../../hooks';

export interface Props {
  contentHtml: string;
  title: string;
  tag?: 'section' | 'article' | 'aside' | 'div';
  className?: string;
}

export const DisclaimerContentBlock = ({
  title,
  contentHtml,
  tag = 'section',
  className,
}: Props) => {
  const theme = useTheme();
  const content = useHtmlReactParser({
    html: contentHtml,
  });
  return (
    <Grid
      className={className}
      as={tag}
      gap={`${theme.x2space}px`}
      backgroundColor="noir"
      borderRadius="x0"
      borderRadiusLg="x1"
      paddingX="x3"
      paddingY="x2"
      data-cy-id={`narrative-${kebabCase(title)}`}
    >
      <Heading
        data-cy-id={`narrative-${kebabCase(title)}-heading`}
        lineClamp={2}
        typography="small"
        as="h2"
        color="whiteRGBA"
        opacity={0.5}
      >
        {title}
      </Heading>
      <Grid
        gap={`${theme.x3spacePx}px`}
        gapMd={`${theme.x2spacePx}px`}
        data-cy-id={`narrative-${kebabCase(title)}-content`}
      >
        <Text as="em" typography="xSmall" color="lightGray">
          {content}
        </Text>
      </Grid>
    </Grid>
  );
};
